<style lang="scss" scoped>
.slide-6 {
  background-image: url(../../../assets/module3/slide2/background-01.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 100px;
  height: calc(100% - 100px);
  padding-right: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.arm {
  z-index: 9;
}
h1 {
  color: white;
  font-size: 117px;
  margin-right: 300px;
}
.content {
  width: 651px;
}
p {
  color: white;
}
h2 {
  color: #beacd4;
  margin-top: 10px;
  font-size: 70px;
}
</style>

<template>
  <div class="slide-6">
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 5"
        src="@/assets/module5/slide6/number-07.png"
        class="chars"
      />
    </transition>

    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 5"
        src="@/assets/module5/slide6/armando-07.png"
        class="chars arm delay-1"
      />
    </transition>

    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 5"
        src="@/assets/module5/slide6/photo-07.png"
        class="chars delay-2"
      />
    </transition>

    <transition name="fadeRight" appear>
      <h1 v-show="slideIndex == 5" class="delay-3">Arman’s</h1>
    </transition>

    <transition name="fadeRight" appear>
      <div v-show="slideIndex == 5" class="content delay-4">
        <p>superpower is his</p>
        <h2>very strong arms</h2>
        <p>
          but if the Evil Clot attacks he will have a stroke and he will
          suddenly lose power in 1 of his arms.
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
